/*
 * push-notification-message (zod)
 */
import { globalCreateExclude, globalUpdateExclude } from "../../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { pushNotificationMessages } from "./push-notification-message.schema"

/* Select */
export type PushNotificationMessage = z.infer<
	typeof selectPushNotificationMessageSchema
>
export const selectPushNotificationMessageSchema = createSelectSchema(
	pushNotificationMessages,
)

/* Filters */
export type PushNotificationMessageFilters = z.infer<
	typeof pushNotificationMessageFiltersSchema
>
export const pushNotificationMessageFiltersSchema = z.object({
	userId: z.string().optional(),
	status: z.string().optional(),
})

/* Create */
export const createPushNotificationMessageSchema = createInsertSchema(
	pushNotificationMessages,
).partial(globalCreateExclude)
export type CreatePushNotificationMessage = z.infer<
	typeof createPushNotificationMessageSchema
>

/* Update */
export const updatePushNotificationMessageSchema = createInsertSchema(
	pushNotificationMessages,
)
	.omit(globalUpdateExclude)
	.required({ id: true })
export type UpdatePushNotificationMessage = z.infer<
	typeof updatePushNotificationMessageSchema
>

/* Delete */
export const deletePushNotificationMessageSchema = createInsertSchema(
	pushNotificationMessages,
).required({ id: true })
export type DeletePushNotificationMessage = z.infer<
	typeof deletePushNotificationMessageSchema
>
